<script>
import { mapGetters } from 'vuex';
import { MESSENGERS } from '../constants/messengers';
import { isDark } from '../helpers/darkHelper';

export default {
  name: 'MessengersAvailability',
  computed: {
    ...mapGetters({
      messengerList: 'messenger/availableMessengers',
    }),
  },
  methods: {
    getColor(messenger) {
      return MESSENGERS[messenger.type].color;
    },
    getBackgroundColor(messenger) {
      return messenger.hover ? this.getColor(messenger) : '';
    },
    setHover(index, isHover) {
      this.messengerList[index].hover = isHover;
    },
    getImageUrl(messenger) {
      return new URL(`../assets/images/messengers/${ messenger.hover ? 'active' : 'inactive' }/${messenger.type.toLowerCase()}.png`, import.meta.url).href;
    },
    open(messenger) {
      window.open(messenger.url, '_blank');
    },
  },
};
</script>

<template>
  <div id="messengerListBox" class="rounded-md dark:bg-slate-700">
    <div v-if="messengerList" class="flex flex-wrap">
      <div
        v-for="(messenger, index) in messengerList"
        :key="index"
        class="border border-solid border-gray-200 rounded-2xl py-2 m-1 flex grow items-center justify-center hover:cursor-pointer messenger-box"
        :style="{ 'background-color': getBackgroundColor(messenger), 'border-color': getColor(messenger) }"
        @mouseenter="setHover(index, true)" @mouseleave="setHover(index, false)" @click="open(messenger)">
        <img :src="getImageUrl(messenger)" class="w-10 h-auto mx-2" />

        <span
          class="messenger-text mr-2"
          :class="{ 'text-white': messenger.hover }"
          >{{ $t('MESSENGERS.' + messenger.type) }}
        </span>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.is-widget-rtl #messengerListBox {
  .messenger-box {
    .messenger-text {
      margin-left: 0.5rem !important;
      margin-right: 0 !important;
    }
  }
}
</style>
